import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import {
  filterAudienceTargetingClauses,
  getFilteredClauseTree,
  getFlattenedClausesFromNestedConditions
} from "@appcues/libcues";
import TargetingDetailsRow from "components/ModalContainer/FlowPublishingModal/TargetingDetailsTable/TargetingDetailsRow";
import { getFrequencyConditions } from "transforms/migrations";
import {
  filterABGroupClauses,
  filterDomainTargetingClauses,
  filterUrlTargetingClauses
} from "utils/conditions";
import { selectAccountFeature } from "reducers/account/features";
import { AB_TESTING } from "constants/features";

const Container = styled.div`
  margin: 1rem;
`;

const Table = styled.table`
  width: 100%;
  margin-top: 0.5rem;
`;

export class TargetingDetailsTable extends Component {
  getUrlClauses = () => {
    const { clauses } = this.props;
    return getFilteredClauseTree(filterUrlTargetingClauses, clauses);
  };

  getDomainClauses = () => {
    const { clauses } = this.props;
    return getFilteredClauseTree(filterDomainTargetingClauses, clauses);
  };

  getFrequencyClauses = () => {
    const { rule } = this.props;
    return getFlattenedClausesFromNestedConditions(
      getFrequencyConditions(rule.id, rule.frequency)
    );
  };

  getAudienceClauses = () => {
    const { clauses } = this.props;
    return getFilteredClauseTree(filterAudienceTargetingClauses, clauses);
  };

  getAbGroupClauses = () => {
    const { clauses } = this.props;
    return getFilteredClauseTree(filterABGroupClauses, clauses);
  };

  render() {
    const { hasABTesting } = this.props;

    return (
      <Container>
        <Table>
          <tbody>
            <TargetingDetailsRow
              label="Page"
              clauses={this.getUrlClauses()}
              omitTailPropertyNames
            />
            <TargetingDetailsRow
              label="Frequency"
              clauses={this.getFrequencyClauses()}
              omitTailPropertyNames
            />
            <TargetingDetailsRow
              label="Domains"
              clauses={this.getDomainClauses()}
              omitTailPropertyNames
            />
            <TargetingDetailsRow
              label="Audience"
              clauses={this.getAudienceClauses()}
              omitTailPropertyNames={false}
            />
            {hasABTesting && (
              <TargetingDetailsRow
                label="A/B Group"
                clauses={this.getAbGroupClauses()}
                omitTailPropertyNames={false}
              />
            )}
          </tbody>
        </Table>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return { hasABTesting: selectAccountFeature(state, AB_TESTING) };
}

export default connect(mapStateToProps)(TargetingDetailsTable);
